module.exports = __webpack_public_path__ + "img/d-5.7f8e3088.png";